<template>
  <div class="page">
    <div class="nav-wrapper">
      <Navbar />
    </div>
    <div class="page-wrapper">
      <div class="filter-wrapper">
        <div class="filter-container">
          <button
            type="button"
            class="link link--filter"
            :class="{
              'link--active':
                !this.filters.hasOwnProperty('expert') &&
                !this.filters.hasOwnProperty('exists[expert]'),
            }"
            @click="expertFilterEstimations"
          >
            {{ $t('filter.all_estimations') }}
          </button>
          <button
            type="button"
            class="link link--filter"
            :class="{
              'link--active':
                this.filters.expert && this.filters.expert === currentUser.id,
            }"
            @click="
              expertFilterEstimations({
                sortKey: 'expert',
                value: currentUser.id,
              })
            "
          >
            {{ $t('filter.my_estimations') }}
          </button>
          <button
            type="button"
            class="link link--filter"
            :class="{
              'link--active': this.filters.hasOwnProperty('exists[expert]'),
            }"
            @click="
              expertFilterEstimations({
                sortKey: 'exists[expert]',
                value: false,
              })
            "
          >
            {{ $t('filter.not_assigned_estimations') }}
          </button>
          <button
            type="button"
            class="link link--filter"
            @click="dateFilterModalShow = true"
          >
            {{ $t('filter.date_filter') }}
          </button>

          <button
            type="button"
            class="link link--filter"
            @click="expertModalShow = true"
          >
            {{ $t('filter.expert_filter') }}
          </button>
        </div>
        <div class="filter-container">
          <SearchInput @update-search-value="filterEstimations" />
          <button
            type="button"
            class="button button--filter"
            @click="helpModalShow = true"
          >
            {{ $t('help') }} <i class="far fa-question-circle"></i>
          </button>
          <Sort :options="dateSortOptions" @action="filterEstimations" />
        </div>
      </div>
      <div class="filter-wrapper">
        <p>{{ $t('display_number_estimations') }} {{ totalEstimations }}</p>
      </div>
      <div class="card-container">
        <EstimationCard
          v-for="(estimation, i) in estimations"
          :key="i"
          :card="estimation"
          @updateEstimation="filterEstimations"
          @fullView="fullView"
        />
      </div>
      <InfiniteScroll
        v-if="estimations.length < totalEstimations"
        @paginate="paginateEstimations"
      />
    </div>
    <HelpModal v-if="helpModalShow" @closeModal="helpModalShow = false" />
    <DateFilterModal
      v-show="dateFilterModalShow"
      @closeModal="dateFilterModalShow = false"
      @filter="dateFilter"
      @eraseDateFilter="deleteDateFilter"
    />
    <ExpertFilterModal
      v-if="expertModalShow"
      :selected-expert="estimations.expert"
      @closeModal="expertModalShow = false"
      @filter="expertFilter"
      @deleteExpertFilter="deleteEstimatedExpertFilter"
    />
  </div>
</template>

<script>
import {
  SearchInput,
  Sort,
  InfiniteScroll,
  DateFilterModal,
} from '../../components/filters';
import Navbar from '../../components/Navbar';
import EstimationCard from '../../components/EstimationCard';
import { EstimationComponent } from '../../mixins';
import HelpModal from '../../components/HelpModal';
import { mapGetters } from 'vuex';
import ExpertFilterModal from '@/components/filters/ExpertFilterModal';

export default {
  components: {
    ExpertFilterModal,
    HelpModal,
    Navbar,
    EstimationCard,
    SearchInput,
    InfiniteScroll,
    Sort,
    DateFilterModal,
  },

  mixins: [EstimationComponent],

  data() {
    return {
      helpModalShow: false,
      dateFilterModalShow: false,
      expertModalShow: false,
      dateSortOptions: [
        {
          title: 'filter.sort.newer',
          sortedElement: 'order[createdAt]',
          order: 'desc',
        },
        {
          title: 'filter.sort.older',
          sortedElement: 'order[createdAt]',
          order: 'asc',
        },
      ],
    };
  },

  computed: {
    ...mapGetters('user', ['currentUser']),
  },

  async created() {
    await this.loadPendingEstimations();
  },

  methods: {
    async loadPendingEstimations() {
      const pendingEstimations = await this.fetchEstimations({ status: 'request' });

      if (!pendingEstimations || !pendingEstimations['hydra:member']) return;

      this.estimations = pendingEstimations['hydra:member'];

      if (!pendingEstimations['hydra:totalItems']) return;

      this.totalEstimations = pendingEstimations['hydra:totalItems'];
    },

    dateFilter(dates) {
      this.filterEstimations({
        sortKey: 'createdAt[after]',
        value: dates[0],
      });
      this.filterEstimations({
        sortKey: 'createdAt[before]',
        value: dates[1],
      });
    },
    expertFilter(expert) {
      this.filterEstimations({
        sortKey: 'expert',
        value: expert[0].id,
      });
    },
    async deleteDateFilter() {
      this.eraseDateFilter();
      await this.loadPendingEstimations();
    },

    async deleteEstimatedExpertFilter() {
      this.eraseEstimatedExpertFilter();
      await this.loadPendingEstimations();
    },
  },
};
</script>
